// Application route paths - organized for better maintainability
export const PATHS = {
  // Public routes (no authentication required)
  LANDING: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  PRIVACY: "/privacy",
  TERMS: "/terms",

  // Protected routes (authentication required)
  DASHBOARD: "/dashboard",
  CLIENT_LIST: "/clients",
  SCAN_LIST: "/scans",
  SCAN_DETAIL: "/scans/:id",
  NEW_SCANS: "/scans/new",
  MONITORING: "/monitoring",
  HEARTBEAT: "/heartbeat",
  HEARTBEAT_NOTES: "/heartbeat/notes",
  REPORTS: "/reports",
  SUPPORT: "/support",
  REPGUARD_INSTALL: "/repguard/install",
  SETTINGS: "/settings",
  ADMIN: "/admin",
  GLOBAL_ADMIN: "/global-admin",
  ONBOARDING: "/onboarding",

  // API paths
  API: {
    LOGIN: "/api/users/login",
    REGISTER: "/api/users/register",
    LOGOUT: "/api/users/logout",
    USER_PROFILE: "/api/users/profile",
    SCANS: "/api/scans",
    REPORTS: "/api/reports",
    CLIENTS: "/api/clients",
    ACCOUNTS: "/api/accounts",
    DASHBOARD: "/api/dashboard",
  },
};

// Route patterns for dynamic routes
export const ROUTE_PATTERNS = {
  CLIENT_DETAIL: "/clients/:id",
  SCAN_DETAIL: "/scans/:id",
  SCAN_FLAGGED_CONTENT: "/scans/:id/flagged-content",
  REPORT_DETAIL: "/reports/:id",
  HEARTBEAT_ACCOUNT: "/heartbeat/:accountId",
  // One pulse in detail. Registered BEFORE HEARTBEAT_ACCOUNT would match it,
  // and every run in the history opens here - previously the page only ever
  // rendered the newest run, so older pulses were listed but unreachable.
  HEARTBEAT_RUN: "/heartbeat/:accountId/runs/:runId",
};

// Route categories for organized management
export const ROUTE_CATEGORIES = {
  PUBLIC: "public",
  PROTECTED: "protected",
  ADMIN: "admin",
  ONBOARDING: "onboarding",
};

// Helper function to build dynamic routes
export const buildRoute = (pattern, params) => {
  let route = pattern;
  Object.entries(params).forEach(([key, value]) => {
    route = route.replace(`:${key}`, value);
  });
  return route;
};

// Navigation items for consistent menu generation

export default PATHS;
